// extracted by mini-css-extract-plugin
export default {"button":"ProjectTrafficLightStatusSwitcher_button__2c3En"};